export default {
    setData: (state, data) => {
        state.socials = data.socials;
        state.contacts = data.contacts;
        state.boundary = data.boundary;
    },
};
